var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.82 29.42h-3.844L22.55 12.525h6.696L27.82 29.42zm-1.922 2.263c.95 0 1.736.31 2.356.93.62.62.93 1.405.93 2.356 0 .95-.31 1.726-.93 2.325-.62.62-1.405.93-2.356.93-.95 0-1.736-.31-2.356-.93-.62-.6-.93-1.374-.93-2.325 0-.95.31-1.736.93-2.356.62-.62 1.405-.93 2.356-.93z",
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 23,
    stroke: "#EBEBEB",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.07565a8beead90a8790e78dfcccd10d2.svg";
export { ForwardRef as ReactComponent };